"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var get_1 = __importDefault(require("lodash/get"));
var enums_1 = require("../Common/utils/enums");
exports.getErrorMessage = function (error) {
    return get_1["default"](error, 'graphQLErrors[0].message') || '';
};
exports.getErrorPayload = function (isRestClient, error) {
    if (isRestClient) {
        return get_1["default"](error, 'networkError.result.errors[0]', {}) || {};
    }
    return get_1["default"](error, 'graphQLErrors[0].extensions.exception') || {};
};
exports.isUserBlocked = function (isRestClient, error) {
    var payload = exports.getErrorPayload(isRestClient, error);
    return payload.code === enums_1.ErrorCodes.TooManyAttempts;
};
exports.triesRemaining = function (isRestClient, error) {
    var payload = exports.getErrorPayload(isRestClient, error);
    return payload.code === enums_1.ErrorCodes.InvalidCode
        ? get_1["default"](payload, 'detail.verification_attempts_remaining')
        : 0;
};
exports.HELP_LINK = 
/* tslint:disable-next-line:max-line-length */
'https://help.doordash.com/consumers/s/article/How-do-I-update-my-account-information';
exports.redirectToNextUrl = function (redirectUrl) {
    var url = redirectUrl;
    // Protect against script injections `next=javascript:alert(document.cookie)`.
    // https://doordash.atlassian.net/browse/FRD-428
    if (!url || url.substring(0, 10) === 'javascript') {
        url = 'https://www.doordash.com';
    }
    window.location.href = url;
};
